import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import BrandLogo from "../BrandLogo";

const navItems = [
  { name: "Home", to: "/" },
  { name: "Programs", to: "/programs" },
  { name: "About", to: "/about" },
  { name: "Verify Certificate", to: "/verify" },
  { name: "Privacy Policy", to: "/privacy-policy" },
  { name: "Terms", to: "/terms-of-service" },
  { name: "Contact", to: "/contact" },
];

const MarketingHeader = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="backdrop-blur-xl bg-white/90 border-b border-slate-200/80 sticky top-0 z-50 shadow-sm shadow-slate-900/5">
      <div className="marketing-container">
        <div className="flex items-center justify-between h-20 sm:h-24">
          <Link to="/" className="flex items-center" data-testid="brand-logo-link">
            <BrandLogo size="lg" sub={false} />
          </Link>

          <nav className="hidden lg:flex items-center gap-1">
            {navItems.map((item) => {
              const active = location.pathname === item.to;
              return (
                <Link
                  key={item.to}
                  to={item.to}
                  data-testid={`nav-${item.name.toLowerCase().replace(/\s+/g, "-")}`}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                    active ? "bg-blue-50 text-blue-700" : "text-slate-600 hover:text-slate-900 hover:bg-slate-50"
                  }`}
                >
                  {item.name}
                </Link>
              );
            })}
          </nav>

          <div className="hidden lg:flex items-center gap-2">
            <Link
              to="/login"
              data-testid="nav-login-btn"
              className="px-4 py-2 rounded-lg text-sm font-medium text-slate-700 hover:bg-slate-100 transition-all"
            >
              Login
            </Link>
            <Link
              to="/register"
              data-testid="nav-register-btn"
              className="px-4 py-2.5 rounded-lg text-sm font-semibold bg-blue-600 hover:bg-blue-700 text-white shadow-sm transition-all"
            >
              Register Now
            </Link>
          </div>

          <button
            onClick={() => setOpen(!open)}
            className="lg:hidden h-10 w-10 inline-flex items-center justify-center rounded-full border border-slate-200 bg-white text-slate-900 shadow-sm hover:bg-slate-50"
            aria-label="Toggle navigation menu"
            data-testid="mobile-menu-toggle"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>

        {open && (
          <div className="lg:hidden pb-5 pt-2 border-t border-slate-200/80">
            <div className="rounded-2xl border border-slate-200 bg-white p-2 shadow-2xl shadow-slate-900/10">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                onClick={() => setOpen(false)}
                className={`block px-4 py-3 rounded-xl text-sm font-semibold transition-all ${
                  location.pathname === item.to ? "bg-blue-50 text-blue-700" : "text-slate-700 hover:bg-slate-50"
                }`}
              >
                {item.name}
              </Link>
            ))}
            <div className="grid grid-cols-2 gap-2 pt-2">
              <Link to="/login" onClick={() => setOpen(false)} className="text-center px-4 py-3 rounded-xl border border-slate-200 text-sm font-semibold text-slate-700">Login</Link>
              <Link to="/register" onClick={() => setOpen(false)} className="text-center px-4 py-3 rounded-xl bg-blue-600 text-white text-sm font-semibold shadow-lg shadow-blue-600/20">Register</Link>
            </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default MarketingHeader;
